import {
  ToggleGroup,
  ToggleGroupItem,
} from '../../../../components/ui/toggle-group';
import { Alumni } from '../../../../lib/types';

function AlumniParser({ alumniSet }: { alumniSet: Alumni[] | [] }) {
  return (
    <section>
      {alumniSet?.length !== 0 && (
        <>
          <h4 className="mb-2">Alumni</h4>
          <ToggleGroup
            type="single"
            className="flex flex-wrap justify-center gap-2 child:capitalize"
          >
            {alumniSet?.map((alum, index) => {
              return (
                <a
                  className="normal normal-pointer normal-no-hover w-fit child:min-w-[10rem]"
                  key={index}
                  href={alum.link}
                  target="_blank"
                >
                  <ToggleGroupItem variant="outline" value={alum.id.toString()}>
                    {alum.name}
                  </ToggleGroupItem>
                </a>
              );
            })}
          </ToggleGroup>
        </>
      )}
    </section>
  );
}

export default AlumniParser;
